import { Avatar, Card, CardContent, Grid, Typography } from '@mui/material';
import { GroupIcon } from '../../Icons'
import { LIST_GROUPS } from "../../../graphql/admin-requests";
import React, { useState } from 'react';
import { useQuery } from "@apollo/client";
import { useTheme } from '@mui/material/styles';


const Groups = (props) => {

    const [count, setCount] = useState(0);
    const theme = useTheme();

    useQuery(LIST_GROUPS, {
        onCompleted: (data) => { setCount(data.allGroups.totalCount) },
        fetchPolicy: 'cache-and-network'
    });

    return (
        <Card sx={{ height: '100%' }} {...props} >
            <CardContent>
                <Grid container spacing={3} sx={{ justifyContent: 'space-between' }}>
                    <Grid item>
                        <Typography color="textSecondary" gutterBottom variant="h6">GROUPES</Typography>
                        <Typography color="textPrimary" variant="h3">{count}</Typography>
                    </Grid>
                    <Grid item>
                        <Avatar sx={{ backgroundColor: theme.palette.primary.main, height: 56, width: 56 }}>
                            <GroupIcon />
                        </Avatar>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
};

export default Groups;